// extracted by mini-css-extract-plugin
module.exports = {"label":"InfoItem_label__3RIkp"};